import AppState from 'models/AppState';
import { BASE_CONFIG_ID } from '../../const';
import Config from 'models/Config';

export const selectBaseConfig = (state: AppState): Config =>
  state.whitelabels.configs.find((config) => config.id === BASE_CONFIG_ID);
